<template>
  <div>
    <Cycles />
  </div>
</template>

<script>
import Cycles from "@/components/Cycles/index.vue";
export default {
  components: {
    Cycles,
  },
};
</script>

<style></style>
